// this doesn't seem to do anything in prod. including just in case
export { default } from 'pages/loyalty/loyalty-claim-points/loyalty-claim-points-process';
